import { render, staticRenderFns } from "./ProposalCompensationView.vue?vue&type=template&id=51f81fbc&scoped=true&"
import script from "./ProposalCompensationView.vue?vue&type=script&lang=js&"
export * from "./ProposalCompensationView.vue?vue&type=script&lang=js&"
import style0 from "./ProposalCompensationView.vue?vue&type=style&index=0&id=51f81fbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f81fbc",
  null
  
)

export default component.exports